import {Component, Input, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../../modules/modal/modal-ref";
import {TypeUtils} from "../../../utils/type-utils";

@Component({
    selector: 'db-notification-modal',
    templateUrl: './notification-modal.component.html',
    styleUrls: ['./notification-modal.component.scss'],
    standalone: false
})
export class NotificationModalComponent implements OnInit {

  @Input() header = '';
  @Input() message = '';
  @Input() buttonTxt = '';
  @Input() discardButtonTxt? = '';
  @Input() secondaryBtnText? = '';
  @Input() leftAlight?: boolean = false;
  @Input() hideCloseBtn?: boolean = false;
  @Input() discardButtonClass = 'ds-btn';
  @Input() buttonAdditionalClass = '';
  @Input() hideDialogDelay = 0;
  @Input() uppercaseWords?: boolean = true;
  public loading: boolean;
  public loadingSecondary: boolean;

  constructor(
    private activeModal: DbActiveModal,
  ) {
  }

  ngOnInit() {
    if (!!this.hideCloseBtn) {
      this.activeModal.hideCloseBtn(true);
    }
  }

  close(value): void {
    this.activeModal.close(value);
  }

  closeDialog(value): void {
    if (TypeUtils.isDefined(this.hideDialogDelay) && this.hideDialogDelay > 0) {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.close(value);
      }, this.hideDialogDelay * 1000);
    } else {
      this.close(value);
    }
  }

  secondaryButtonAction(value): void {
    if (TypeUtils.isDefined(this.hideDialogDelay) && this.hideDialogDelay > 0) {
      this.loading = true;
      setTimeout(() => {
        this.loadingSecondary = false;
        this.close(value);
      }, this.hideDialogDelay * 1000);
    } else {
      this.close(value);
    }
  }


}
